module.exports = __webpack_public_path__ + "static/media/select-up.8f077f85.svg";